export const CARRIERS = [
  { code: 'yurtici', name: 'Yurtiçi Kargo' },
  { code: 'aras', name: 'Aras Kargo' },
  { code: 'mng', name: 'MNG Kargo' },
  { code: 'ptt', name: 'PTT Kargo' },
  { code: 'surat', name: 'Sürat Kargo' },
  { code: 'hepsijet', name: 'HepsiJet' },
  { code: 'ups', name: 'UPS' },
  { code: 'dhl', name: 'DHL' },
  { code: 'other', name: 'Diğer (manuel)' }
];

const URL_BY_CODE = {
  yurtici: (no) =>
    `https://www.yurticikargo.com/tr/online-servisler/gonderi-sorgula?code=${encodeURIComponent(no)}`,
  aras: (no) =>
    `https://www.araskargo.com.tr/tr/cargo_tracking?code=${encodeURIComponent(no)}`,
  mng: (no) => `https://www.mngkargo.com.tr/track/?code=${encodeURIComponent(no)}`,
  ptt: (no) => `https://gonderitakip.ptt.gov.tr/Track/Verify?q=${encodeURIComponent(no)}`,
  surat: (no) =>
    `https://www.suratkargo.com.tr/KargoTakip/?kargotakipno=${encodeURIComponent(no)}`,
  hepsijet: (no) => `https://www.hepsijet.com/gonderi-takibi/${encodeURIComponent(no)}`,
  ups: (no) => `https://www.ups.com/track?tracknum=${encodeURIComponent(no)}`,
  dhl: (no) => `https://www.dhl.com/tr-tr/home/tracking.html?tracking-id=${encodeURIComponent(no)}`
};

export const getOrderTrackingUrl = (order) => {
  const no = order?.tracking_number?.trim?.() || order?.tracking_number;
  if (!no) return null;
  const code = order.shipping_carrier_code;
  const fn = code && URL_BY_CODE[code];
  return fn ? fn(String(no)) : null;
};

export const getOrderCarrierLabel = (order) =>
  order?.shipping_carrier ||
  CARRIERS.find((c) => c.code === order?.shipping_carrier_code)?.name ||
  '';
